var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14V25.77C24 25.8089 23.9922 25.8475 23.977 25.8833C23.9618 25.9192 23.9396 25.9516 23.9116 25.9787C23.8836 26.0057 23.8504 26.0269 23.8141 26.0409C23.7777 26.0548 23.7389 26.0613 23.7 26.06H6.33C6.29108 26.0613 6.25229 26.0548 6.21595 26.0409C6.1796 26.0269 6.14644 26.0057 6.11844 25.9787C6.09044 25.9516 6.06819 25.9192 6.05299 25.8833C6.03779 25.8475 6.02998 25.8089 6.03 25.77V14",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.51 20.25H12.49V26.06H17.51V20.25Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.91998L26.95 16.87",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4.91998L3.04999 16.87",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIco);
export default __webpack_public_path__ + "static/media/homeIco.c85ed39888bd1be3be430f0a838acc57.svg";
export { ForwardRef as ReactComponent };